export default __webpack_public_path__ + "media/images/x-header-social-a64107ac5e1dcd3342889c73ac5002f3.svg";